<template>
  <div id="content" class="detail">
    <div class="detailtop">
      <div class="backPackList" @click="backPackList()"><Icon type="ios-arrow-back" />返回</div>
      <div class="lesimg"><img :src="imgurl" alt=""></div>
      <div class="description">
        <div class="packname">{{packname}}</div>
        <div class="lesbox">
          <div class="itemGrade" :title="gradeName">年级：{{gradeName}}</div>
          <div class="itemTerm">册别：{{catalogName}}</div>
        </div>
        <div class="lesbox">
          <div class="itemSubject" :title="subjectName">学科：{{subjectName}}</div>
          <div class="itemVersion" :title="versionName">版本：{{versionName}}</div>
        </div>
        <div class="lesbox">
          <div class="itemType">类型：{{type == 0 ? '同步课' : '专题课'}}</div>
        </div>
      </div>
    </div>
    <div class="zhang">
      <Collapse accordion @on-change="open" v-model="valueName">
        <Panel  v-for="(item,index) in listChapter" :key="index" :name="item.id">
          {{item.name}}
          <div slot="content">
            <div class="jiang">
              <Collapse accordion @on-change="openLecture">
                <Panel  v-for="(n,m) in listLecture" :key="m" :name="n.id">
                  {{n.name}}
                  <div slot="content">
                    <div class="jie">
                      <Collapse accordion @on-change="openSection" v-model="value4">
                        <Panel  v-for="(k,l) in listSection" :key="l" :name="k.id">
                          {{k.name}}
                          <div slot="content">
                            <div class="detailcontent">
                              <div class="text">备课资源：</div>
                              <div class="video" @click="lookVideo()"><img src="/static/images/video_icpn.png" alt="">微课视频（{{videoNum}}）</div>
                              <div class="exercises" @click="lookExercises()"><img src="/static/images/xiti_icon.png" alt="">习题（{{exercisesNum}}）</div>
                              <div class="ppt" @click="lookPpt()"><img src="/static/images/ppt_icon.png" alt="">PPT（{{pptNum}}）</div>
                              <div class="question" @click="lookQuestion()"><img src="/static/images/xuean_icon.png" alt="">学案（{{questionNum}}）</div>
                              <div class="other" @click="lookOther()"><img src="/static/images/datum_icon.png" alt="">其他资源（{{otherNum}}）</div>
                            </div>
                          </div>
                        </Panel>
                      </Collapse>
                    </div>
                  </div>
                </Panel>
              </Collapse>
            </div>
          </div>
        </Panel>
      </Collapse>
    </div>
    <message v-show="isShowMessage" :msg="msg" @isShowMsg="isShowMsg" :isShowMessage="isShowMessage"></message>
  </div>
</template>
<script>
  import api from '../../utils/api.js';
  import bus from '../../assets/eventBus/enentBus.js';
  import cookie from '../../assets/getCookie.js';
  import message from '../Message/Message'
  export default {
    name:'PackageDetail',
    props:{
      packageTest:{
        type:Object,
        default:{
          packageId:null
        }
      }
    },
    data() {
      return {
        urlHttp: '/testIp',
        packageId: null,
        packageData:{},
        imgurl:'https://qcban.aixuetang.com/res/',              //备课包图片地址  线上域名
        value: null,
        value1: '1',
        value3: '1',
        value4: '0',
        chapterId:0,
        lectureId:0,
        sectionId:0,
        videoNum:0,
        exercisesNum:0,
        pptNum:0,
        questionNum:0,
        otherNum:0,
        listChapter:[],
        listLecture:[],
        listSection:[],
        packname:null,
        gradeName:'',
        catalogName:'',
        subjectName:'',
        versionName:'',
        type:0,
        isShowMessage:false,
        msg:null,
        valueName:null

      }
    },
    mounted() {
      let that = this;
       bus.$on('packageId',function(msg){
           that.packageId = msg;
           that.getBaseData(that.packageId);
           that.getDetailData(that.packageId);
       })
      this.$nextTick(()=>{
        $(document).scrollTop(0);
      })
    },
    watch:{
      packageTest:function(newVal,oldVal){
        let that =this;
        //console.log(newVal,"newVal");
        if(this.packageTest.isPackage){
          that.getBaseData(this.packageTest.packageId);
          that.getDetailData(this.packageTest.packageId);
        }
      }
    },
    methods:{
      //获取备课包基础信息
      getBaseData(id) {
        let that = this;
        const url =  '/axt-resources/package_prepare/queryCourseById/' + id;
        //console.log(id,"oooooooooo")
        api.getListAPI(url).then(res => {
          //数据处理
          that.imgurl = that.imgurl + res.data.data.imgPath;
          that.packname = res.data.data.name;
          that.type = res.data.data.type;
          that.gradeName = res.data.data.gradeName.length >3 ?res.data.data.gradeName.slice(0,3)+'...':res.data.data.gradeName;
          that.catalogName = res.data.data.catalogName;
          that.subjectName = res.data.data.subjectName.length >3 ?res.data.data.subjectName.slice(0,3)+'...':res.data.data.subjectName;
          that.versionName = res.data.data.versionName.length >3 ?res.data.data.versionName.slice(0,3)+'...':res.data.data.versionName;
        }).catch(err => {
          console.log(err)
        })
      },
      //获取章
      getDetailData(id){
        const that = this;
        const url =  '/axt-resources/package_prepare/listChapter';
        var params = {
            packageCourseId:id,
            status: "1"
        };
        //console.log(params)
        api.postFormAPI(url,params).then(res => {
          //数据处理
          //console.log(res.data.data, "lllllllll");
          that.listChapter = res.data.data;
        }).catch(err => {
          console.log(err)
        })
      },
      //获取讲
      getLectureList(courseId,chapterId){
        this.listLecture = [];
        const that = this;
        const url =  '/axt-resources/package_prepare/listLecture';
        var params = {
            packageCourseId:courseId,
            packageChapterId:chapterId,
            status: "1"
        };
        //console.log(params)
        api.postFormAPI(url,params).then(res => {
          //数据处理
          //console.log(res.data.data, "kkkkkk");
          that.listLecture = res.data.data;
        }).catch(err => {
          console.log(err)
        })
      },
      //获取节
      getlistSection(courseId,chapterId,lectureId){
        //this.listSection = [];
        const that = this;
        const url =  '/axt-resources/package_prepare/listSection';
        var params = {
            packageCourseId:courseId,
            packageChapterId:chapterId,
            packageLectureId:lectureId,
            status: "1"
        };
        //console.log(params)
        api.postFormAPI(url,params).then(res => {
          //数据处理
          that.listSection = res.data.data;
          that.value4 = res.data.data[0].id;
          that.sectionId = res.data.data[0].id;
          that.getSectionContentNum(that.packageId,that.chapterId,that.lectureId,res.data.data[0].id)
        }).catch(err => {
          console.log(err)
        })
      },
      //获取讲节上资源数量
      getSectionContentNum(courseId,chapterId,lectureId,sectionId){
        const that = this;
        //console.log(courseId,chapterId,lectureId,sectionId,"111111111")
        //获取节上微课数量
        that.getSectionVideoCount(courseId,chapterId,lectureId,sectionId);
        //获取节上习题数量
        that.getSectionQuestionCount(courseId,chapterId,lectureId,sectionId);
        //获取节上PPT数量
        that.getSectionMaterialCount(courseId,chapterId,lectureId,sectionId,0)
        //获取节上学案数量
        that.getSectionMaterialCount(courseId,chapterId,lectureId,sectionId,1)
        //获取节上其他数量
        that.getSectionMaterialCount(courseId,chapterId,lectureId,sectionId,2)
      },
      //获取节上微课数量
      getSectionVideoCount(courseId,chapterId,lectureId,sectionId){
        const that = this;
        const url =  '/axt-resources/package_prepare/selectVideoCountByQuery';
        var params = {
            packageCourseId:courseId,
            packageChapterId:chapterId,
            packageLectureId:lectureId,
            packageSectionId:sectionId,
            useType: 0
        };
        //console.log(params)
        api.postFormAPI(url,params).then(res => {
          //数据处理
          that.videoNum = res.data.data;
        }).catch(err => {
          console.log(err)
        })
      },
      //获取节上习题数量
      getSectionQuestionCount(courseId,chapterId,lectureId,sectionId){
        const that = this;
        const url =  '/axt-resources/package_prepare/selectQuestionCountByQuery';
        var params = {
            packageCourseId:courseId,
            packageChapterId:chapterId,
            packageLectureId:lectureId,
            packageSectionId:sectionId,
            useType: 0,
            qstAutoJudge:null
        };
        //console.log(params)
        api.postFormAPI(url,params).then(res => {
          //数据处理
          //console.log(res.data, "exe");
          that.exercisesNum = res.data.data;
        }).catch(err => {
          console.log(err)
        })
      },
      //获取节上PPT数量
      getSectionMaterialCount(courseId,chapterId,lectureId,sectionId,type){
        const that = this;
        const url =  '/axt-resources/package_prepare/selectMaterialCountByQuery';
        var params = {
            packageCourseId:courseId,
            packageChapterId:chapterId,
            packageLectureId:lectureId,
            packageSectionId:sectionId,
            useType: 0,
            materialType: type
        };
        //console.log(params)
        api.postFormAPI(url,params).then(res => {
          //数据处理
         // console.log(res.data,type, "kkkkkk");
          if(type == 0) {
            that.pptNum = res.data.data;
          }else if(type == 1) {
            that.questionNum = res.data.data;
          }else {
            that.otherNum = res.data.data;
          }
        }).catch(err => {
          console.log(err)
        })
      },
      //打开章
      open(name){
       this.valueName = name;
       const that = this;
       //console.log(that.packageId,name);
       that.chapterId = name[0];
       if(name.length > 0){
         that.getLectureList(that.packageId,name[0]);
       }

      },
      //打开讲
      openLecture(name){
        const that = this;
        that.lectureId = name[0];
        //console.log(that.packageId,that.chapterId,name[0],"ooooooo");
        if(name.length > 0){
          that.getlistSection(that.packageId,that.chapterId,name[0]);
        }

      },
      //打开节
      openSection(name){
        const that = this;
        //console.log(name,"name")
        that.sectionId = name[0];
        //console.log(that.packageId,that.chapterId,that.lectureId,name[0],"1111111");
        if(name.length > 0){
          that.getSectionContentNum(that.packageId,that.chapterId,that.lectureId,name[0])
        }

      },
      //返回列表
      backPackList(){
        this.valueName = null;
        const that = this;
        this.$emit('isPackList',false);
      },
      //查看微课视频
      lookVideo(){
        let websiteid = localStorage.getItem('websiteId');
        const cookie_token = cookie.getCookie('AXY_'+websiteid+'_access_token')
        if(cookie_token == null || cookie_token == 'null') {
          this.isShowMessage = true;
          this.msg = '您尚未登录,请登录后查看！';
          return
        }
        const that = this;
        const packageId = that.packageId;
        //console.log(that.packageId,'packageId',that.chapterId,'chapterId',that.lectureId,'lectureId',that.sectionId,'sectionId',that.videoNum,that.exercisesNum,that.pptNum,that.questionNum,that.otherNum,"kkkkkkkkkkkkk”")
        this.$emit('isPrepare',false);
        this.$nextTick(() => {
             bus.$emit('prepareData',{packageId:that.packageId,chapterId:that.chapterId,lectureId:that.lectureId,sectionId:that.sectionId,videoNum:that.videoNum,exercisesNum:that.exercisesNum,pptNum:that.pptNum,questionNum:that.questionNum,otherNum:that.otherNum,type:1})
        })

      },
      //查看习题
      lookExercises(){
        let websiteid = localStorage.getItem('websiteId');
        const cookie_token = cookie.getCookie('AXY_'+websiteid+'_access_token')
        if(cookie_token == null || cookie_token == 'null') {
          this.isShowMessage = true;
          this.msg = '您尚未登录,请登录后查看！';
          return
        }
        const that = this;
        const packageId = that.packageId;
        this.$emit('isPrepare',false);
        this.$nextTick(() => {
             bus.$emit('prepareData',{packageId:that.packageId,chapterId:that.chapterId,lectureId:that.lectureId,sectionId:that.sectionId,videoNum:that.videoNum,exercisesNum:that.exercisesNum,pptNum:that.pptNum,questionNum:that.questionNum,otherNum:that.otherNum,type:2})
        })
      },
      //查看PPT
      lookPpt(){
        let websiteid = localStorage.getItem('websiteId');
        const cookie_token = cookie.getCookie('AXY_'+websiteid+'_access_token')
        if(cookie_token == null || cookie_token == 'null') {
          this.isShowMessage = true;
          this.msg = '您尚未登录,请登录后查看！';
          return
        }
        const that = this;
        const packageId = that.packageId;
        this.$emit('isPrepare',false);
        this.$nextTick(() => {
             bus.$emit('prepareData',{packageId:that.packageId,chapterId:that.chapterId,lectureId:that.lectureId,sectionId:that.sectionId,videoNum:that.videoNum,exercisesNum:that.exercisesNum,pptNum:that.pptNum,questionNum:that.questionNum,otherNum:that.otherNum,type:3})
        })
      },
      //查看学案
      lookQuestion(){
        let websiteid = localStorage.getItem('websiteId');
        const cookie_token = cookie.getCookie('AXY_'+websiteid+'_access_token')
        if(cookie_token == null || cookie_token == 'null') {
          this.isShowMessage = true;
          this.msg = '您尚未登录,请登录后查看！';
          return
        }
        const that = this;
        const packageId = that.packageId;
        this.$emit('isPrepare',false);
        this.$nextTick(() => {
             bus.$emit('prepareData',{packageId:that.packageId,chapterId:that.chapterId,lectureId:that.lectureId,sectionId:that.sectionId,videoNum:that.videoNum,exercisesNum:that.exercisesNum,pptNum:that.pptNum,questionNum:that.questionNum,otherNum:that.otherNum,type:4})
        })
      },
      //查看其他
      lookOther(){
        let websiteid = localStorage.getItem('websiteId');
        const cookie_token = cookie.getCookie('AXY_'+websiteid+'_access_token')
        if(cookie_token == null || cookie_token == 'null') {
          this.isShowMessage = true;
          this.msg = '您尚未登录,请登录后查看！';
          return
        }
        const that = this;
        const packageId = that.packageId;
        this.$emit('isPrepare',false);
        this.$nextTick(() => {
             bus.$emit('prepareData',{packageId:that.packageId,chapterId:that.chapterId,lectureId:that.lectureId,sectionId:that.sectionId,videoNum:that.videoNum,exercisesNum:that.exercisesNum,pptNum:that.pptNum,questionNum:that.questionNum,otherNum:that.otherNum,type:5})
        })
      },
      isShowMsg(msg){
          this.isShowMessage = false;
      }
    },
    components:{message}
  }
</script>

<style>
  #content.detail {
    margin-top: 30px;
    min-height: 600px;
  }
  .detailtop {
    width: 100%;
    padding: 17px;
    box-shadow: 0px 0px 13px 0px rgba(231, 239, 245, 0.5);
    border-radius: 8px;
    border: 1px solid #EBEBEB;
    text-align: left;
    display: flex;
    flex-direction: row;
    margin-bottom: 20px;
    position: relative;
  }
  .backPackList {
    position: absolute;
    right: 20px;
    cursor: pointer;
  }
  .backPackList:hover {
    color: #2d8cf0;
  }
  .lesimg {
    margin-right: 30px;
  }
  .lesimg img {
    width: 118px;
    height: 155px;
  }
  .packname {
    font-size: 18px;
    font-weight: 500;
    color: #34495E;
    line-height: 27px;
    margin: 15px 0 10px;
  }
  .lesbox {
    display: flex;
    flex-direction: row;
    margin-bottom: 10px;
  }
  .lesbox div {
    margin-right: 30px;
  }
 #content.detail {
   text-align: left;

 }
 .detailcontent {
   display: flex;
   flex-direction: row;
   margin-bottom: 10px;
 }
 .detailcontent .text {
    margin-right: 20px;
    font-size: 14px;
 }
 .detailcontent .video, .detailcontent .exercises, .detailcontent .ppt, .detailcontent .question, .detailcontent .other{
  margin-right: 20px;
  cursor: pointer;
  font-size: 14px;
}
 .detailcontent .video:hover, .detailcontent .exercises:hover, .detailcontent .ppt:hover, .detailcontent .question:hover, .detailcontent .other:hover {
   color: #2d8cf0;
 }
.detailcontent img {
 height: 13px;
 margin-right: 10px;
}
.zhang {
  min-height:550px;
}
.zhang > .ivu-collapse {
  border: none;
  background:none;
}
.zhang > .ivu-collapse>.ivu-collapse-item>.ivu-collapse-header {
  border-bottom: 0;
  background:#f7f7f7;
  border-radius: 8px;
  overflow: hidden;
}
.zhang > .ivu-collapse>.ivu-collapse-item {
  border-top: none;
  margin-bottom: 16px;
  border-radius: 8px;
  overflow: hidden;
}
.jiang > .ivu-collapse {
  border: none;
  background:none;
}
.jiang > .ivu-collapse>.ivu-collapse-item>.ivu-collapse-header {
  border-bottom: 0;
}
.jiang > .ivu-collapse>.ivu-collapse-item {
  border-top: none;
  margin-bottom: 16px;
}
.jie > .ivu-collapse {
  border: none;
  background:none;
}
.jie > .ivu-collapse>.ivu-collapse-item>.ivu-collapse-header {
  border-bottom: 0;
}
.jie > .ivu-collapse>.ivu-collapse-item {
  border-top: none;
  background:#f7f7f7;
  margin-bottom: 16px;
  border-radius: 8px;
  overflow: hidden;
}
.jie > .ivu-collapse>.ivu-collapse-item .ivu-collapse-content {
  background:#f7f7f7;
}
.jie > .ivu-collapse-content>.ivu-collapse-content-box {
  padding-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/PackageDetail/PackageDetail.vue